import React from 'react';
import './Clients Value Prop.css';

const ClientsValueProp = () => {
  return (
    <section className="clients-section">
      <div className="section-header">
        <p className="section-tagline">FOR BUSINESSES</p>
        <h2>How HyrEx helps your business?</h2>
      </div>
      <div className="clients-content">
        <div className="text-content">
          <ul>
            <li>
              <strong>High-quality insights:</strong> Use our RAG-based GenAI, OBKA, to get quick on-demand insights from highly vetted expert professionals.
            </li>
            <li>
              <strong>Real-time access:</strong> Our professional network model allows experts to answer questions as they get it.
            </li>
            <li>
              <strong>Cost-effective solutions:</strong> Our clients save 50% on their research spend by eliminating low-quality interactions and content.
            </li>
          </ul>
        </div>
        <div className="image-content">
        <video
          src="/clientvideo.mp4" // Adjust the path if needed
          autoPlay
          loop
          muted
          playsInline
          style={{ width: '80%', height: 'auto' }}
        >
          Your browser does not support the video tag.
        </video>
        </div>
      </div>
    </section>
  );
};

export default ClientsValueProp;
